module.exports = __webpack_public_path__ + "img/LIFTQRCode.c93e9d6b.png";